<template>
  <div 
    v-if="isVisible"
    :class="['checkpoint-tools-menu-item', { 'selected': selected }]"
    @click="$emit('click', $event)"
  >
    <div class="menu-item-content">
      <div class="icon-wrapper">
        <Icon :name="iconName" :color="currentColor" />
      </div>
      <span class="label">{{ variant }}</span>
    </div>
    <div v-if="selected" class="underline"></div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '@components/icons/Icon.vue';

const props = defineProps({
  variant: {
    type: String,
    required: true,
    validator: (value) => typeof value === 'string' && value.trim().length > 0
  },
  video: {
    type: Boolean,
    default: false
  },
  selected: {
    type: Boolean,
    default: false
  }
});

defineEmits(['click']);

const isVisible = computed(() => {
  // Based on behavior image: Proposed Inspection only shows when selected
  if (props.variant === 'Proposed Inspection') {
    return props.selected;
  }
  return true;
});

const currentColor = computed(() => {
  return props.selected ? 'active' : 'dark';
});

const iconName = computed(() => {
  if (!props.video) return 'checkpoint_info';
  if (currentColor.value === 'active') return 'play_square_icon';
  return 'checkpoint_video';
});
</script>

<style scoped>
@import '@components/CheckpointToolsMenuItem/checkpointToolsMenuItem.css';
</style>
